import { useClaimant } from '../context/col'
import { CaseTypeType } from '../models/caseReport'

/**
 * Hook zjistí caseType z kontextu aplikace.
 *
 * @returns
 */
function useCaseType(): CaseTypeType | null {
  const { state } = useClaimant()
  //const caseType: CaseTypeType = state.caseType

  // XXX prazdny retezec musime vymitit
  let caseType: string | null = state.caseType
  if (caseType === '') {
    caseType = null
  }
  if (caseType == null) {
    return null
  } else {
    // TODO lze mit kontrolu, ze je opravdu ve vyctu ;)
    return caseType as CaseTypeType
  }
}

export default useCaseType
